import { useModal } from 'react-modal-hook'
import { OnlyModelProps, SiteRole } from 'src/types'
import { Button } from 'src/components/ui'
import { useSite } from 'src/contexts/site'
import { useModelOverviewStore } from '../Overview/modelOverview.state'
import { CopyModelModal } from './CopyModelModal'

export function CopyButton({ model }: OnlyModelProps): JSX.Element {
  const isModelEditing = useModelOverviewStore(state => state.isModelEditing)
  const { rootLink, id, viewerRole } = useSite()

  const isReader = viewerRole === SiteRole.READER

  const [showModal, closeModal] = useModal(() => {
    return (
      <CopyModelModal
        onClose={closeModal}
        model={model}
        rootLink={rootLink}
        factoryId={id}
      />
    )
  }, [model, rootLink])

  return (
    <>
      <Button
        title="Copy Model"
        variant="secondary"
        onClick={showModal}
        disabled={isReader || isModelEditing}
      />
    </>
  )
}
